import o from "./indexConfig.ce.vue2.js";
import t from "./indexConfig.ce.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const i = /* @__PURE__ */ r(o, [["styles", [t]]]);
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/indexConfig.ce.vue.js
// module id = 1225
// module chunks = 41